const fileStateName = (state) => {
  const stateName = {
    temp: 'Temporário',
    document_docgo: 'DocGo',
    draft: 'Rascunho',
    minute: 'Minuta',
    minute_draft: 'Rascunho de Minuta',
    import: 'Importado',
    document_attached: 'DocGo',
    unlinked: 'Desvinculado',
  };
  return stateName[state];
};

export default fileStateName;



// WEBPACK FOOTER //
// ./src/mixins/file-state-name.js